export default {
  '1:1': '1x1',
  '3:4': '3x4',
  '4:3': '4x3',
  '5:3': '5x3',
  '16:9': '16x9'
}
